import { toPercentage } from '@/util/mathUtil';
<template>
  <div v-if="loan" id="DocumentLimitTransactionNormalTerms" class="sun not-full">
    <div class="title">{{ list[0].title }}</div>
    <div class="content">{{ list[0].content }}</div>
    <v-collapse-wrapper
      ref="NormalTerms"
      @afterClose="isCollapse = false"
      @afterOpen="isCollapse = true"
    >
      <div v-collapse-content>
        <div :key="index" v-for="(item, index) in list" v-show="index > 0">
          <div class="title">{{ item.title }}</div>
          <div class="content">{{ item.content }}</div>
        </div>
      </div>
      <div v-collapse-toggle>
        <button class="collapse">
          {{ isCollapse ? '내용 접기' : '내용 더보기' }}
        </button>
      </div>
    </v-collapse-wrapper>
  </div>
</template>

<script>
import { toPercentage } from '@/util/mathUtil'
export default {
  name: 'DocumentLimitTransactionNormalTerms',
  props: ['isCompleted', 'loan'],
  data: function () {
    return {
      isCollapse: false,

    }
  },
  computed: {
    list() {
      return [
        {
          title: '제1조 한도거래 및 개별거래',
          content:
            `한도거래 함은 거래 기간 중 한도 금액 범위 내에서 대출금을 자유롭게 신청하고 지급받는 것을,
          개별거래라 함은 대출 금액을 한도거래 기간 전 또는 만료일에 직접 일시 상환하거나 거래
          기간까지 분할하여 상환하는 것을 말한다.`
        },
        {
          title: '제2조 상환방식',
          content:
            `번개입금 선정산 또는 펌뱅킹 이체출금 금원의
                ${this.repaymentRatio}%를 상환재원으로하며, 대출금의 이자, 원금순으로 상환한다. 상환은
                선정산금원으로 진행하며, 선정산 중단 또는 매출 미발생시 고객의 직접납부 또는 펌뱅킹
                방식으로 납부한다.
            `
        },
        {
          title: '제3조 지연손해금',
          content:
            '이자, 분할상환금, 분할상환 원리금을 대출 만기일까지 전액 상환하지 못하거나 제4조에 의한 기한의 이익을 상실한 때에는 그 다음날부터 남은 대출 잔액에 대해 연체이자율에 의한 지연손해금을 지급하기로 한다.',
        },
        {
          title: '제4조 기한의 이익상실',
          content: '한도거래약서 특약사항 1호에 의한다.',
        },
        {
          title: '제5조 관할법원의 합의',
          content: `본 계약에 관하여 채무자의 책임있는 사유로 제4조 기한의 이익상실 특약사항에 관한
                사유가 발생되어 채권자와 채무자 사이에 소송의 필요가 생긴 때에는 그 채권의 관리를
                위하여 채권자 소재지 관할법원으로 한다.`
        }
      ]
    },
    /**
     * 상환비율
     */
    repaymentRatio() {
      return this.loan.offer.repayment_ratio ? toPercentage(this.loan.offer.repayment_ratio, 0) : 10
    },
  },
  created() {},
  destroyed() {},
  methods: {
    open(refName) {
      this.$refs[refName].open()
    },
  },
}
</script>

<style lang="scss" scoped>
#DocumentLimitTransactionNormalTerms {
  padding-bottom: 30px;
  .title {
    font-weight: 600;
    font-size: 16px;
    margin-top: 30px;
  }
  .content {
    font-size: 16px;
    line-height: 1.5;
    margin-top: 13px;
  }
  button.collapse {
    width: 100%;
    height: 50px;
    font-weight: 600;
    font-size: 18px;
    color: #727d8c;
    border-radius: 24px;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    margin-top: 20px;
  }
}
</style>
